import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  summary: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    gap: 'var(--ui-spacer-xs)',
    fontSize: '1.4rem',
  },
  info: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    textTransform: 'capitalize',
    margin: '0',
    fontSize: '0.86em',
    fontWeight: 400,
    lineHeight: 1.143,
    color: `${theme.colors.disabled}`,
    '& span': {
      font: 'inherit',
      lineHeight: 'inherit',
    },
  },
  row: {},
  textBlock: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    textTransform: 'capitalize',
    fontSize: '1em',
    fontWeight: 400,
    lineHeight: 1.143,
    '& span': {
      font: 'inherit',
      lineHeight: 'inherit',
      '&:first-child': {
        textAlign: 'left',
      },
    },
  },
  total: {
    fontSize: '1.143em',
    fontWeight: 600,
    lineHeight: 1.25,
    marginTop: 'var(--ui-spacer-m)',
  },
  paymentRequest: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 'var(--ui-spacer-s)',
    flex: 1,
  },
  paymentTypeIcon: {
    marginBottom: 0,
    display: 'block',
    maxHeight: '2.8rem',
  },
}))

export default useStyles
